import React, {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
} from 'react';
import StrategyPlayerMenu from './components/StrategyPlayerMenu';

const StrategyPlayerMenuContext = createContext(null);

export function StrategyPlayerMenuProvider({ children }) {
  const [menu, setMenu] = useState(null);

  const open = useCallback((payload) => {
    if (!payload?.player?._id) return;
    setMenu({
      mode: 'actions',
      x: payload.x || 0,
      y: payload.y || 0,
      player: payload.player,
      slot: payload.slot || payload.player.current_position || null,
      inXi: !!payload.inXi,
    });
  }, []);

  const close = useCallback(() => setMenu(null), []);

  const showSubs = useCallback(() => {
    setMenu((current) => (current ? { ...current, mode: 'subs' } : null));
  }, []);

  const value = useMemo(
    () => ({ open, close, showSubs, menu }),
    [open, close, showSubs, menu]
  );

  return (
    <StrategyPlayerMenuContext.Provider value={value}>
      {children}
      {menu ? (
        <StrategyPlayerMenu menu={menu} onClose={close} onShowSubs={showSubs} />
      ) : null}
    </StrategyPlayerMenuContext.Provider>
  );
}

export function useStrategyPlayerMenu() {
  return (
    useContext(StrategyPlayerMenuContext) || {
      open: () => {},
      close: () => {},
      showSubs: () => {},
      menu: null,
    }
  );
}
